module.exports = __webpack_public_path__ + "img/GAME_SOCCER1.3e744b7d.jpg";